import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'
import {actionFacturacionEmision} from '../../actions/action-creators'
import {State} from '../../reducers'
import {useHistory} from 'react-router'

import DocumentoTributarioV1 from './Components/DetalleDocumento/contents/DocumentoTributarioV1'
import FooterResumenV1 from './Components/GenerarDocumento/footers/FooterResumenV1'
import FooterFinalizacionV1 from './Components/GenerarDocumento/footers/FooterFinalizacionV1'
import ModalsResumenControlV1 from './Components/ResumenDocumento/ModalsResumenControlV1'
import { Link } from 'react-router-dom'
import DynamicResumenContent from './Components/ResumenDocumento/DynamicResumenContent'

const ResumenDocumento = () => {
  const history = useHistory()
  const {activeDoc} = useSelector((state: State) => state.documentos)
  const facturaEmitida = useSelector((state: State) => state.facturacion.facturaEmitda)
  const arrayP = useSelector((state: State) => state.facturacion.arrayProductos)
  const uuid = useSelector((state: State) => state.facturacion.datosUUID)
  const dispatch = useDispatch()
  const actionsFE = bindActionCreators(actionFacturacionEmision, dispatch)

  useEffect(() => {
    if (uuid === null) actionsFE.facturacionGetUUID(activeDoc.idDoc);
    if (arrayP.length === 0) history.push('/otros-documentos/emitir/formulario')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <ModalsResumenControlV1 />
      <div className='header-link'>
        <Link to={"/otros-documentos/emitir/formulario"} className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>{activeDoc?.title}</h3>
      </div>
      <div className='separador'></div>
      <div
        id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6'
        className='w-layout-layout bill-section wf-layout-layout'
      >
        <DynamicResumenContent />
      </div>
    </>
  )
}

export default ResumenDocumento
